module.exports = (__webpack_require__(97008))(24);